import { COLOR_NEUTRAL_4 } from 'constants/colors';
import styled from 'styled-components';
import { Button, Descriptions, Skeleton } from 'UI';

export const StepDescriptions = styled(Descriptions)`
  width: 100%;

  & .ant-descriptions-header {
    background-color: ${COLOR_NEUTRAL_4};
  }
`;

export const TitleWrapper = styled.div`
  width: 100%;
  background-color: transparent;
  padding: 1rem 1.5rem;
  display: flex;
  gap: 1rem;
`;

// export const ActionButton = styled.button`
//   background: transparent;
//   font-size: 0.875rem;
//   color: ${COLOR_LINK};
//   outline: none;
//   border: none;
//   cursor: pointer;
//   width: 100%;
//   text-align: left;
//   padding: 0;

//   &:hover {
//     text-decoration: underline;
//     background: transparent;
//     color: ${COLOR_LINK};
//   }

//   &:active, &:focus {
//     background: transparent;
//     color: ${COLOR_LINK};
//   }

//   &.ant-btn:not([disabled]):hover {
//     text-decoration: underline;
//   }
// `;

export const ExtraButton = styled(Button)`
`;

export const SeedStatusSkeleton = styled(Skeleton)`
  & .ant-skeleton-paragraph {
    margin-bottom: 0;
  }
`;
